import React, { Component } from 'react'
import Loader from '../loader';
//Service import
import service from '../../services'
//moment import
import _ from 'lodash'
import moment from "moment-timezone";

import $ from 'jquery'
import FpgMinusIcon from '../../icons/fpgminusicon';
import ErrorPopUp from '../errorPopUp';

let sub;

export default class DailySpecials extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            imagePreloader:false,
            dailySpecialsArray:[],
            dailySpecialsArraySearch:[]
        }
        this.apiserve = new service();
    }

    componentDidMount = () => {
      this.getDailySpeacialsDetails()
    }

    componentWillUnmount = () => {
      sub.unsubscribe();
    }

    // Dummy API
    getDailySpeacialsDetails = () => {
      this.festivalDailySpecials()
        sub = this.apiserve.getevent().subscribe(response => {
          switch (response.event) {
            case "FestivalVillage|DailySpecialOfferEvent|get":
            if (!response.error) {
                this.setState({
                    loaderFlag:false,
                    dailySpecialsArray:response.data.dailySpecialEvent ? response.data.dailySpecialEvent : [],
                    updateDate: response.data.updatedAt,
                    // updatedBy:response.data.updatedBy
                })
            }
            else
            {
                this.setState({
                    errorPopup:true,
                    errorMsg: response.data.error ? response.data.error : response.data 
                })
            }
            break;
            case "FestivalVillage|DailySpecialOfferEvent|searchOfferEvent":
                if (!response.error) {
                    if(this.state.searchField && this.state.searchField.length){
                    const getSpecialsData = this.state.dailySpecialsArraySearch && this.state.dailySpecialsArraySearch.map(item => item._id);
                    const getSpecialList =this.state.featuredEvent && this.state.featuredEvent.map(item => item._id);
                    const getSpecial = response.data.docs.filter(
                        item => !(getSpecialsData&&getSpecialsData.includes(item._id) || getSpecialList&&getSpecialList.includes(item._id))
                    );
                    
                    this.setState({
                        dailySpecialsArraySearch:getSpecial,
                    })
                    } 
                }
                break;
                case "FestivalVillage|DailySpecialOfferEvent|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag:false,
                            },()=>{
                                this.festivalDailySpecials()
                            })
                            this.apiserve.success("Daily Special Offers Updated Successfully.")
                    }
                    else
                    {
                        this.setState({
                            errorPopup:true,
                            errorMsg: response.data.error ? response.data.error : response.data 
                        })
                    }
        }
        });
    };

    festivalDailySpecials = () => {
        this.apiserve.sendevent("FestivalVillage|DailySpecialOfferEvent|get", {});
        this.setState({ loaderFlag: true })
    }

    onSearchFilter = e => {
      this.setState(
        {
          [e.target.name]: e.target.value
        },
        () => {
          if (this.state.searchField.length) {
            this.apiserve.sendevent("FestivalVillage|DailySpecialOfferEvent|searchOfferEvent", {
              filter: this.state.searchField
            });
          }
          this.setState({
            dailySpecialsArraySearch:[]
        })
        }
        
      );
    };

    onPromotionalEvent = e => {
      this.setState(
        {
          [e.target.name]: e.target.value
        },
        () => {
          if (this.state.promotionalEvent.length) {
            this.apiserve.sendevent("FestivalVillage|FestivalVillageHomePage|searchEvent", {
              filter: this.state.promotionalEvent
            });
          }else{
            this.setState({
              promotionalEventId:""
            })
          }
        }
      );
    };

    searchAddFeatured = (item) => {
      let data = {
        _id:item._id,
        eventId:item
      }
      this.setState({
        dailySpecialsArray: [...this.state.dailySpecialsArray, item],
        searchField:'',
        dailySpecialsArraySearch:[]
      });
    }

    revoveFeatured = i => {
      var dailySpecialsArray = this.state.dailySpecialsArray.filter(_=>_._id !== i)
      this.setState({
        dailySpecialsArray: dailySpecialsArray
      });
    }

    getSpecialSubmit  = (e) => {
        e.preventDefault();
        let getSpecialList = this.state.dailySpecialsArray.map(element => {
            return element._id
        });
        
        this.apiserve.sendevent("FestivalVillage|DailySpecialOfferEvent|create", {dailySpecialEvent:getSpecialList});
      }

    errorMsgPopup = () => {
        this.setState({
            errorPopup:false
        })
    }

 
    render() {
        return (
            <div className="right_side_wrapper partnerEventAdminView_wrapper fest_contents p_0">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="text_left">
                            <div>
                                Select Up to 6 Daily Special Offers
                            </div>
                        </p>
                    </li>
                </ul>    
                
                {/* {this.state.updateDate === undefined ? '' :
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                  <p></p>
                  <p className="update_date">
                    Last Update: {moment(this.state.updateDate).tz("US/Mountain").format('h')}:{moment(this.state.updateDate).tz("US/Mountain").format('mm')} {moment(this.state.updateDate).tz("US/Mountain").format('A')}{' '}
                  MT- {moment.tz(this.state.updateDate, "US/Mountain").format('MM/DD/YYYY')}{' '}
                  Last Updated By: {this.state.updatedBy && this.state.updatedBy.fname} {this.state.updatedBy && this.state.updatedBy.lname}
                  </p>
                </div>
                } */}

                <div className="fpg_tabcontent">
                    <div className="EventTitle_block">
                      <div className="textarea_block form_group d_flex">
                        <h5 className="left_label">Daily Special Offers</h5>
                        <div className="relative ml_25 product_coupon_form p_0"  style={{width:"400px"}} >
                        <div className="form_group_textarea" id="open1">
                            <input
                                type="text"
                                name="searchField"
                                placeholder="Type event name to find and select multiples by keeping entering"
                                value={this.state.searchField}
                                onChange={this.onSearchFilter}
                                style={{width:"100%",marginLeft:"0px"}}
                                className="m_0"
                                autoComplete="off"    
                            />
                        </div>

                            <ul className="suggession_coupon mx_100" id="popup1">
                            {this.state.dailySpecialsArraySearch.map((item,i)=>(
                            <li onClick={()=>this.searchAddFeatured(item)}>
                                {item.eventTitle ? item.eventTitle : item.offerTitle}
                            </li>
                            ))}
                        </ul>

                        <ul className="featured_remove">
                            {this.state.dailySpecialsArray.map((item,i)=>(
                            <li>
                            <div className="inner_remove d_flex">
                                <p>{item?.eventTitle ? item?.eventTitle :  item?.offerTitle}</p>
                                <span className="pointer" onClick={e => this.revoveFeatured(item._id)}><FpgMinusIcon width="20px" height="20px" color="#7758B3" /></span>
                            </div>
                            </li>
                            ))}
                            
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="EventTitle_block">
                        <div className="textarea_block form_group d_flex">
                            <h5 className="left_label" style={{width:"130px"}}>&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                            <div className="btn_wrapper field_row ml_25">
                                    <button className="grayBTN">Cancel</button>
                                    <button className="orangeBTN active" type='button' onClick={(e)=>this.getSpecialSubmit(e)}>Submit</button>
                            </div> 
                        </div>
                    </div>
                </div>
                {this.state.errorPopup ? 
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                                />    
                            : ''
                        }
            </div>

            
            
        )
       
    }
}
